"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProgress;

function getProgress(props) {
  var progressInfo = props.progressInfo;

  if (!progressInfo) {
    return null;
  }

  return progressInfo.progress;
}